import type {SearchIndexAlias} from "@buildwithflux/constants";

export const SEARCH_INDEX_ALIASES = ["projects", "components", "users", "orgs"] as const;

export function formatSearchSectionCount(count: number, resultLimit: number): string {
    return count >= resultLimit ? "many" : count.toLocaleString("en-US");
}

export function getSearchFallbackType(
    currentType: SearchIndexAlias,
    resultCounts: Readonly<Partial<Record<SearchIndexAlias, number>>>,
): SearchIndexAlias | null {
    if (SEARCH_INDEX_ALIASES.some((type) => resultCounts[type] === undefined)) return null;
    if ((resultCounts[currentType] ?? 0) > 0) return null;

    let fallbackType: SearchIndexAlias | null = null;
    let fallbackCount = 0;

    for (const type of SEARCH_INDEX_ALIASES) {
        if (type === currentType) continue;
        const count = resultCounts[type] ?? 0;
        if (count <= fallbackCount) continue;
        fallbackType = type;
        fallbackCount = count;
    }

    return fallbackType;
}
